import { Components } from '@mui/material';

export function getMuiSvgIcon(): Components['MuiSvgIcon'] {
  return {
    styleOverrides: {
      root: {
        fill: 'none',
        strokeWidth: 2,
      },
    },
  };
}
